<template>
	<div v-parallax-fit="parallax" class="slide-note" id="slidenote-1">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/04_letter_01.png">
	</div>
</template>

<script>
import { store } from '../../store';

export default {
	inject: ['helpers'],
	data() {
		return {
			store,
			subtitlesUrl: {
				'en': '/themes/rise-theme/resources/assets/audio/henry/2.srt',
				'es': '/themes/rise-theme/resources/assets/audio/henry/2_es.srt'
			},
			mutationObserver: null,
			parallax: [
				{
					start: 3600,
					end: 4600,
					fromStyle: { transform: 'translateX(40%) translateY(-550%)' },
					toStyle: { transform: 'translateX(40%) translateY(100%)' },
					easing: 'linear'
				},
				{
					start: 8000,
					end: 9000,
					fromStyle: { transform: 'translateX(40%) translateY(100%)' },
					toStyle: { transform: 'translateX(40%) translateY(550%)' },
					easing: 'linear'
				}
			]
		}
	},
	created() {
		this.$watch('store.lang', newVal => {
			if (Object.values(this.subtitlesUrl).includes(this.$subtitlesUrl.value)) {
				this.$subtitlesUrl.value = this.subtitlesUrl[newVal]
			}
		}, { immediate: true });
	},
	mounted() {
		const audio = '/themes/rise-theme/resources/assets/audio/henry/2.mp3';
		const evidence = {
			items: [
				{
					image: '/themes/rise-theme/dist/images/estate/character-view/henry/evidence/2.jpg.webp',
					url: 'https://sanantonioreport.org/past-housing-zoning-practices-contribute-to-todays-housing-gap/',
					link_title: {
						'en': "Past Housing, Zoning Practices Contribute to Today's Housing Gap",
						'es': 'Las Prácticas Pasadas de Vivienda y Zonificación Contribuyen a la Brecha de Vivienda de Hoy'
					},
				}
			],
			text: {
				'en': '"As neighborhoods near downtown become more desirable, low-income urban core residents are vulnerable to displacement. The market is solving our reinvestment problem, but it’s not solving the displacement problem..."',
				'es': '"A medida que los vecindarios cercanos al centro se vuelven más deseables, los residentes del núcleo urbano de bajos ingresos son vulnerables al desplazamiento. El mercado está resolviendo nuestro problema de reinversión, pero no está resolviendo el problema del desplazamiento..."'
			}
		};
		const text = {
			'en': 'As the city of San Antonio has invested heavily in development near downtown, the rising home values are enticing real estate investors to buy older properties, raze them, or flip them.',
			'es': 'Como la ciudad de San Antonio ha invertido mucho en el desarrollo cerca del centro de la ciudad, el aumento del valor de las viviendas está atrayendo a los inversores inmobiliarios a comprar propiedades más antiguas, demolerlas o voltearlas.'
		};

		this.mutationObserver = new window.MutationObserver(mutationList => {
			mutationList.forEach(mutation => {
				if (mutation.target.style.transform == 'translateX(40%) translateY(100%)') {
					this.$evidence.value = JSON.stringify(evidence);
					this.$audioUrl.value = audio;
					this.$subtitlesUrl.value = this.subtitlesUrl[this.store.lang];
					this.$readMore.value = text;
				}
			});
		});

		this.mutationObserver.observe(document.querySelector('#slidenote-1'), {
			attributes: true,
			attributeFilter: ['style']
		});
	},
	unmounted() {
		this.mutationObserver.disconnect();
	},

}
</script>
